/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import Refinement from 'cio/app-models/conditions/refinement';
import ActionCondition from 'cio/app-models/conditions/action';
import AuthService from 'cio/services/auth';
import SegmentModel from 'cio/models/segment';
import FiltersService from 'cio/services/filters';
import { getConditionCampaignFirstStarted } from 'cio/utils/conditions';

interface CioConditionEditorActionArgs {
  // backwards compat
  classNames?: string;
  condition: ActionCondition;
  allowMessageWildcardSelection?: boolean;
  allowInParentWildcardSelection?: boolean;
  customerItems: { value: string; label: string }[];
  actionItems: { value: string; label: string }[];
  changeType: () => unknown;
  onRemove: () => unknown;
  disableRefinement?: boolean;
  segment: SegmentModel;
  disabled: boolean;
}

export default class CioConditionEditorAction extends Component<CioConditionEditorActionArgs> {
  @service auth!: AuthService;
  @service filters!: FiltersService;

  constructor(owner: unknown, args: CioConditionEditorActionArgs) {
    super(owner, args);

    this.args.condition.set(
      'campaignFirstStarted',
      getConditionCampaignFirstStarted(this.args.condition, this.filters),
    );
  }

  @action
  addRefinement() {
    this.args.condition.set('refinement', Refinement.create());
  }

  @action
  removeRefinement() {
    this.args.condition.set('refinement', null);
  }
}
